import type { AxiosInstance } from 'axios';
import type { GenerateRequest } from '@/types';

export const generate = async (
  api: AxiosInstance,
  messages: GenerateRequest['messages'],
  max_tokens: number,
  temperature: number,
  top_p: number,
): Promise<Response> => {
  const token = localStorage.getItem('accqsure_jwt');

  const init: RequestInit = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      messages,
      max_tokens,
      temperature,
      top_p,
    }),
  };

  const response = await fetch(`${api.defaults.baseURL}/text/generate`, init);

  return response;
};

